<template>
  <div>
    <input
      type="file"
      name=""
      id=""
      class="hidden"
      ref="fileInputRef"
      @change="handleFileUpload"
    />
    <button
      @click="fileInputRef?.click()"
      name="Upload image"
      title="Upload image"
      type="button"
      class="relative cursor-pointer bg-gray-100 flex items-center justify-center size-24 min-w-24 rounded-full"
    >
      <BaseLoader v-if="loading" />
      <Icon
        v-else
        name="tabler:library-plus-filled"
        size="32"
        weight="thin"
        class="text-gray-400"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["handle-upload"]);

const props = withDefaults(
  defineProps<{
    loading?: boolean;
  }>(),
  {
    loading: false,
  },
);

const fileInputRef = ref<HTMLInputElement | null>(null);

const handleFileUpload = async (e: Event) => {
  const target = e.target as HTMLInputElement;

  // 1. Check if target exists
  // 2. Check if target.files exists (not null)
  // 3. Check if there is at least one file
  if (target && target.files && target.files.length > 0) {
    const file = target.files[0];
    if (!file) return;
    emit("handle-upload", file);
  }
};
</script>
